/**
 * Viewport + scroll offsets for positioning a fixed QMenu anchor (RoosterEditor pattern).
 * @param {import('@tiptap/core').Editor} editor
 * @param {number} pos — document position (usually cursor after `#`)
 */
export function menuCoordsBelowPos(editor, pos) {
    const coords = editor.view.coordsAtPos(Math.min(pos, editor.state.doc.content.size));
    return {
        x: coords.left + (typeof window !== 'undefined' ? window.scrollX : 0),
        y: coords.bottom + (typeof window !== 'undefined' ? window.scrollY : 0),
    };
}
